module.exports = __webpack_public_path__ + "static/egyptian-fitted-sheet-dusty-rose-1-05ec534d8d0788b479bee49278bb4ecf.png";